import MainCatalogsEditorBase from '../../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './AddressMainCategoriesEditor.html?raw';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../../moreCore/UI/CheckBox/CheckBox';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class AddressMainCategoriesEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    amc_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    amc_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    amc_Input_TextColor: HTMLInputElement;
    amc_Input_BackgroundColor: HTMLInputElement;
    amc_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;
    amc_Checkbox_Accommodation: MdsLax<InstanceType<typeof CheckBox>>;

    formData: MainCatalogTypes.AddressMainCategories_SaveData = {
        ID: "",
        is_new_status: null,
        description: "",
        note: "",
        order: null,
        coloration: null,
        is_accommodation: null
    };

    prepareFormData(data?: MainCatalogTypes.AddressMainCategories_LoadData): void {

        if (data) {

            this.amc_Input_Description.setValue(data.description, true);
            this.amc_Input_Note.setValue(data.note, true);

            this.amc_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.amc_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.amc_Input_Order.setValue(data.order, true);

            this.amc_Checkbox_Accommodation.setValue(data.is_accommodation, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.amc_Input_Description.setValue("", true);
            this.amc_Input_Note.setValue("", true);
                 
            this.amc_Input_BackgroundColor.value = "#ffffff";
            this.amc_Input_TextColor.value = "#000000";

            this.amc_Input_Order.setValue(null, true);

            this.amc_Checkbox_Accommodation.setValue(false, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData();
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(): void {

        this.formData.description = this.amc_Input_Description.getValue();
        this.formData.note = this.amc_Input_Note.getValue();

        this.formData.order = this.amc_Input_Order.getValue();

        this.formData.is_accommodation = this.amc_Checkbox_Accommodation.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.amc_Input_TextColor.value;
        let backHex = this.amc_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }

    _onChangeServiceCategoryInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.amc_Input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.description) b = false;

        return b;
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.AddressMainCategory;

        this.amc_Input_Description.setMaxLength(255);
        this.amc_Input_Note.setMaxLength(2000);
        this.amc_Input_Note.setValidationEnabled(false);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(AddressMainCategoriesEditor.prototype, {
  amc_Input_Description: () => (new Edit()),
  amc_Input_Note: () => (new Edit()),
  amc_Input_Order: () => (new NumberInput()),
  amc_Checkbox_Accommodation: () => (new CheckBox()),
});
export default mdsWidget(AddressMainCategoriesEditor);